import { Component, OnInit, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/Rx';
import {
    NgForm,
    FormControl,
    FormBuilder,
    FormGroup,
    Validators,
    ReactiveFormsModule,
    EmailValidator,
    AbstractControl
} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { __moduleName, CanDeactivateGuard } from '../../../interfaces';

import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { FormLabelComponent } from '../../../components/form/label/label.component';
import { FormMessageComponent } from '../../../components/form/message/message.component';

import { UserUrl } from '../../../shared/urls/user.url';
import { Utility } from '../../../common/utility';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { OrganizationModel } from '../../../models/organization/organization.model';
import { CompanyAccountService } from './company-account.service';
import { CountryModel } from '../../../models/master-data/countries.model';
import { OrganizationUrl } from '../../../shared/urls/company-account.url';
import { DiscountModel } from '../../../models/master-data/discount.model';
import { MasterDataUrl } from '../../../shared/urls/master-data.urls';
import { CurrencyNumberPipe } from '../../../pipes/currency-number.pipe';
import { SharedService } from '../../../shared/services/share.services';

@Component({
    selector: 'modify-company-account',
    templateUrl: 'modify-company-account-popup.component.html',
    providers: [CompanyAccountService, CurrencyNumberPipe]
})
export class ModifyCompanyAccountPopupComponent implements OnInit {
    title: string;
    organizationForm: FormGroup;
    organizationModel = new OrganizationModel('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '0.00', '');
    formMessage = '';
    currentDate: any;
    countries = new Array<CountryModel>();
    discounts = new Array<DiscountModel>();
    id: any;
    isSuccess = false;

    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public dialogService: DialogService,
        public utility: Utility,
        private companyAccountService: CompanyAccountService,
        public dialogRef: MdDialogRef<ModifyCompanyAccountPopupComponent>,
        @Inject(MD_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        this.id = this.data.id;
        this.getList();
        this.createForm();
        this.initValue();
        if (this.id) {
            this.title = 'Update Organization';
            // this.organizationModel = this.companyAccountService.getCompanyAccount(
            //     this.id);
            this.getCompanyAccount(this.id);
        } else {
            this.organizationModel.active = true;
            this.organizationModel.code = 'N/A';
            this.title = 'Add New Organization';
        }

        // Limited Amount range 0 to 99999999.99
        this.organizationForm.controls['LimitedAmount'].valueChanges.subscribe(number => {
          if (parseFloat(number) === null) { return; }
          if (parseFloat(number) > 99999999.99) {
            this.organizationForm.controls['LimitedAmount'].setValue('99999999.99');
          }
          if (parseFloat(number) < 0) {
            this.organizationForm.controls['LimitedAmount'].setValue('0');
          }
        });
    }

    createForm() {
        this.organizationForm = this.formBuilder.group({
            OrgCode: '',
            Name: ['', [Validators.required]],
            Contact: '',
            Salutation: '',
            Telephone: ['', [Validators.required]],
            Address1: ['', [Validators.required]],
            Address2: ['', [Validators.required]],
            Address3: '',
            Address4: '',
            Fax: '',
            Memo: '',
            Email: ['', [ValidationService.isValidEmail]],
            Country: '',
            Discount: '',
            Active: '',
            CreatedDate: '',
            LimitedAmount: '',
            Note: ''
        });
        // Update
        if (this.id) {
            this.organizationForm.addControl('Active', new FormControl(''));
            this.organizationForm.addControl('PatientRegPassword', new FormControl(''));
            this.organizationForm.addControl('PatientRegCount', new FormControl(''));
            this.organizationForm.addControl('PatientRegContact', new FormControl(''));
            this.organizationForm.addControl('PatientRegExpires', new FormControl(''));
        }

    }

    initValue() {
        // this.organizationModel.Country = 'Ireland';
        // this.organizationForm.controls['Discount'].setValue(this.organizationModel.discount);
        this.organizationModel.createdDate = this.companyAccountService.getCurrentDate();
        // this.generateOrgCode();
    }


    close() {
        this.dialogRef.close(this.isSuccess);
    }

    onSubmit() {
      if (this.organizationForm.valid) {
        this.organizationModel.limitedAmount = this.convertString(this.organizationModel.limitedAmount);
        if (this.organizationModel.id) {
          const organizationId = OrganizationUrl.ORGANIZATION_UPDATE.replace('{id}', this.organizationModel.id);
          this.baseService.put(organizationId, JSON.stringify(this.organizationModel)).subscribe(
            (result) => {
              if (result) {
                this.isSuccess = true;
                this.dialogService.openSuccessDialog({
                  message: AppMessages.dialog.updateMessage.replace('content', 'Organization')
                });
                this.close();
              }
            }
          );

        } else {
          this.initValue();
          this.baseService.postData(OrganizationUrl.ORGANIZATION_ADD, this.organizationModel).subscribe(
            (result) => {
              if (result) {
                this.isSuccess = true;
                this.dialogService.openSuccessDialog({
                  message: AppMessages.dialog.createMessage.replace('content', 'Organization')
                });
                this.close();
              }
            }
          );
        }
      }
    }


    getCompanyAccount(id) {
        this.baseService.getById(OrganizationUrl.ORGANIZATION_GET, id).subscribe(
            (result) => {
                let address = new Array<string>();
                const data = result.json();
                if (typeof data.limitedAmount === 'number') {
                  data.limitedAmount = data.limitedAmount.toString();
                }
                this.organizationModel = data;
                address = data.address;
                this.organizationModel.address1 = address['0'];
                this.organizationModel.address2 = address['1'];
                this.organizationModel.address3 = (address['2'] === null) ? '' : address['2'];
                this.organizationModel.address4 = (address['3'] === null) ? '' : address['3'];
            }, (error) => { }
        );
    }

    getList() {
        const urlCountry = UserUrl.GET_USER_COUNTRY;
        const urlDiscount = MasterDataUrl.GET_DISCOUNT_LIST;
        // return this.http.get(url).map(this.extractData);

        this.baseService.getData(urlCountry).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.countries = data;
                    if (!this.id) {
                        this.organizationModel.country = localStorage.getItem('countryId');
                    }
                }
            },
            error => {
                console.log(error);
            }
        );

        this.baseService.getData(urlDiscount).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.discounts = data;
                    if (!this.id) {
                        this.organizationModel.discount = this.discounts.find(d => d.name === 'Standard').id;
                    }
                }
            },
            error => {
                console.log(error);
            }
        );
    }

  /**
   * Convert number for directive appCurrencyNumber
   * @param control
   */
  convertString(value) {
    if (value) {
      if (typeof value === 'string' && value.includes('.')) {
        if (value.split('.')[1].length === 3) {
          value = value.slice(0, -1);
        }
      }
      return value.toString();
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-company-accounts/modify-company-account-popup.component.ts